import React from 'react';
import { useNavigate } from 'react-router-dom';
import { sourceImageUrl } from '../../lib/marketDb';
import { formatSar, toSar } from '../../lib/marketPricing';
import { keepSourceCard } from '../../pages/MarketSourcePrepare';

// Results from MAABAR's suppliers that are not in the catalog yet
// (market-source-search, by photo or by words). Nothing names a source:
// pictures come from market-image by opaque ref, titles in Arabic. Opening a
// result goes straight to /market/prepare/:ref, which shows this card at once
// while the product is prepared (imported on demand, the same screening and
// publication rules as the catalog) and then becomes the product page.

const T = {
  ar: { from: 'من', view: 'عرض المنتج' },
  en: { from: 'From', view: 'View product' },
};
T.zh = T.en;

/** One result, as a card (also used inside a mixed list — the photo search's). */
export function SourceCard({ r, lang = 'ar', exchangeRates }) {
  const nav = useNavigate();
  const c = T[lang] || T.ar;
  const openResult = () => { keepSourceCard(r); nav(`/market/prepare/${r.ref}`); };
  const title = (lang === 'ar' ? r.title_ar : null) || r.title_en || '';
  const sar = toSar(r.price_cny, exchangeRates);
  return (
    <div className="mk-card mk-source-card" data-source-result={r.ref}>
      <button type="button" className="mk-card-media" onClick={openResult} aria-label={c.view}>
        <img src={sourceImageUrl(r.ref)} alt="" loading="lazy" onError={(e) => { e.currentTarget.style.visibility = 'hidden'; }} />
      </button>
      <div className="mk-card-body">
        <p className="mk-card-title" dir={lang === 'ar' && r.title_ar ? 'rtl' : 'ltr'}>{title}</p>
        {sar != null && <p className="mk-price" data-source-price={sar}>{c.from} {formatSar(sar)}</p>}
        <button type="button" className="mk-btn" data-source-open={r.ref} style={{ width: '100%', height: 36, marginTop: 6 }} onClick={openResult}>
          {c.view}
        </button>
      </div>
    </div>
  );
}

export default function SourceResults({ results, lang = 'ar', exchangeRates }) {
  return (
    <div className="mk-grid cols-4">
      {results.map((r) => <SourceCard key={r.ref} r={r} lang={lang} exchangeRates={exchangeRates} />)}
    </div>
  );
}
